import React, { useEffect, useRef, useState } from "react";
import { Empty, Tabs, Steps } from "antd";
import Box from "@mui/material/Box";
import { Button, Checkbox, Form, Input, Select } from "antd";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import dateFormat from "dateformat";

import {
  FileWordOutlined,
  FileDoneOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import MainHeader from "../MainHeader/MainHeader";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import Tabss from "../Intruction/Tabs";
import { CKEditor } from "ckeditor4-react";
import { toast } from "react-toastify";
import { Alert } from "antd";
import TextEditor from "../TextEditor";
import { Upload } from 'antd';
import {
  CloudUploadOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
  FileOutlined,
  FilePdfOutlined,
  FileJpgOutlined,
  FilePptOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import Dowolland from "../Icons/Dowolland";
import Delete from "../../assets/icon/delete.svg";
import { fileKind } from "../AddForm1/FormSection";
import "../AddForm1/form.scss";

const kindIcon = {
  pdf: <FilePdfOutlined />,
  word: <FileWordOutlined />,
  ppt: <FilePptOutlined />,
  img: <FileJpgOutlined />,
  other: <FileOutlined />,
};

const { Step } = Steps;
const { TabPane } = Tabs;
const { TextArea } = Input;

// Backend fayl yo'lini string, nisbiy yo'l yoki obyekt ko'rinishida qaytarishi mumkin
const toFileUrl = (value) => {
  const path =
    typeof value === "string"
      ? value
      : value?.url || value?.file || value?.path || null;
  if (!path) return null;
  if (/^(https?:|blob:)/.test(path)) return path;
  return url.eds.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
};

function DuplicateIntruction({ t }) {
  const editorRef = useRef(null);

  const lan = useSelector((state) => state.langReducer);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [data, setDatas] = useState();
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const [editable, setEditable] = useState(false);
  const [error, setError] = useState();
  const [cerificate_file, setCerificateFile] = useState(null);
  const [duplicate_app_file, setDuplicateAppFile] = useState(null);
  const [textValue, setTextValue] = useState('');
  const [general, setgeneral] = useState({ uz: "", ru: "", en: "" });

  const [fileList, setFileList] = useState([]);
  const [fileAppList, setAppFileList] = useState([]);
  const appInputRef = useRef(null);
  const certInputRef = useRef(null);
  const [dragOver, setDragOver] = useState(null);

  const [usage, setusage] = useState({ uz: "", ru: "", en: "" });
  const [prevention, setprevention] = useState({ uz: "", ru: "", en: "" });

  useEffect(() => {
    axios
      .get(url.url + `/duplicate-application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        setDatas(res.data.data);
        setCerificateFile(res.data.data.certificate_file);
        setDuplicateAppFile(res.data.data.duplicate_app_file);
        setgeneral(res.data.data.drug.instruction?.general);
        setusage(res.data.data.drug.instruction?.usage);
        setprevention(res.data.data.drug.instruction?.prevention);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
        // if (err.response.status == 404) window.location = "/404";
        if (err.response.status == 405) toast.error(err.response.data.error);
      });
  }, []);
  const handleSave = () => {
    if (!cerificate_file || !duplicate_app_file) {
      toast.error("Iltimos, barcha maydonlarni to‘ldiring");
      setError(['Iltimos, barcha maydonlarni to‘ldiring']);
      return;
    }
    const formData = new FormData();
    formData.append('cerificate_file', cerificate_file);
    formData.append('duplicate_app_file', duplicate_app_file);
    axios
      .post(url.url + `/duplicate-application/${searchParams.get("id")}/instruction`, formData, {
        headers: headers(),
      })
      .then((res) => {
        if (res.status == 200) {
          setError();
          navigate({
            pathname: "/account/duplicate-applications",
          });
          toast.success(t("Success!"));
        }
      })
      .catch((err) => {
        setError(err.response.data.errors);
      });
  };
  const [keys, setKeys] = useState("1");

  const changeTab = (activeKey) => {
    setKeys(activeKey);
  };
  useEffect(() => {
    axios
      .get(url.url + `/duplicate-application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        if (res.data.data.editable == 1) setEditable(true);
      });
  }, [lan]);

  useEffect(() => {
    const fileUrl = cerificate_file instanceof File ? null : toFileUrl(cerificate_file);
    if (fileUrl) {
      setFileList([
        {
          uid: '-1',
          name: fileUrl.split('/').pop() || 'eski_sertifikat.pdf',
          status: 'done',
          url: fileUrl,
        },
      ]);
    }
  }, [cerificate_file]);

  useEffect(() => {
    const fileUrl = duplicate_app_file instanceof File ? null : toFileUrl(duplicate_app_file);
    if (fileUrl) {
      setAppFileList([
        {
          uid: 'duplicate-2',
          name: fileUrl.split('/').pop() || 'eski_duplikat_app.pdf',
          status: 'done',
          url: fileUrl,
        },
      ]);
    }
  }, [duplicate_app_file]);

  const handleBeforeUpload = (file) => {
    setCerificateFile(file);

    setFileList([
      {
        uid: String(Date.now()),
        name: file.name,
        status: 'done',
        url: URL.createObjectURL(file),
      },
    ]);

    return false;
  };
  const handleDuplicateBeforeUpload = (file) => {
    setDuplicateAppFile(file);

    setAppFileList([
      {
        uid: String(Date.now()),
        name: file.name,
        status: 'done',
        url: URL.createObjectURL(file),
      },
    ]);

    return false;
  };


  return (
    <div>
      <MainHeader title={t("Edit application")} />

      <div className="add-application">
        <Box sx={{ width: "100%" }}>
          <Steps>
            <Step
              status="finish"
              title={t("Application")}
              icon={<SolutionOutlined />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (searchParams.get("con_id"))
                  navigate({
                    pathname: "/account/duplicate-applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                      con_id: searchParams.get("con_id"),
                    })}`,
                  });
                else
                  navigate({
                    pathname: "/account/duplicate-applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                    })}`,
                  });
              }}
            />
            <Step
              status="process"
              title={t("Additional information")}
              icon={<FileDoneOutlined />}
            />
          </Steps>
        </Box>
      </div>
      <section className="af-card doc-card">
        <div className="af-card__head">
          <div className="af-card__title">
            <span className="af-card__num">
              <FileTextOutlined />
            </span>
            <h5>{t("Additional_information")}</h5>
          </div>
          {(() => {
            const done = [fileAppList, fileList].filter((l) => l.length).length;
            const c = 2 * Math.PI * 18;
            return (
              <div className="doc-ring">
                <svg width="44" height="44" viewBox="0 0 44 44">
                  <circle cx="22" cy="22" r="18" className="doc-ring__bg" />
                  <circle
                    cx="22"
                    cy="22"
                    r="18"
                    className={
                      done === 2
                        ? "doc-ring__val doc-ring__val--full"
                        : "doc-ring__val"
                    }
                    strokeDasharray={c}
                    strokeDashoffset={c * (1 - done / 2)}
                  />
                </svg>
                <div>
                  <b>{done}/2</b>
                  <span>{t("sections_filled")}</span>
                </div>
              </div>
            );
          })()}
        </div>

        <div className="dup-note">
          <label className="titleee" htmlFor="dup-note">
            {t("Additional_information")}
          </label>
          <Input.TextArea
            id="dup-note"
            placeholder="Qo‘shimcha maʼlumot yozing"
            value={textValue}
            onChange={(e) => setTextValue(e.target.value)}
            autoSize={{ minRows: 3, maxRows: 8 }}
          />
        </div>

        <div className="doc-list">
          {[
            {
              letter: "A",
              title: t("Reason for duplication"),
              list: fileAppList,
              ref: appInputRef,
              onFile: handleDuplicateBeforeUpload,
              onRemove: () => {
                setAppFileList([]);
                setDuplicateAppFile(null);
              },
            },
            {
              letter: "B",
              title: t("Old certificate"),
              list: fileList,
              ref: certInputRef,
              onFile: handleBeforeUpload,
              onRemove: () => {
                setFileList([]);
                setCerificateFile(null);
              },
            },
          ].map((tile) => {
            const item = tile.list[0];
            const kind = item ? fileKind(item.name) : "other";
            return (
              <div
                key={tile.letter}
                className={item ? "doc-cat doc-cat--done" : "doc-cat"}
              >
                <input
                  type="file"
                  ref={tile.ref}
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const f = e.target.files?.[0];
                    if (f) tile.onFile(f);
                    e.target.value = "";
                  }}
                />
                <div className="doc-cat__head">
                  <span className="doc-cat__num">
                    {tile.letter}
                    {item ? <CheckCircleFilled className="doc-cat__tick" /> : null}
                  </span>
                  <div className="doc-cat__title">{tile.title}</div>
                  <span className={item ? "doc-count doc-count--ok" : "doc-count"}>
                    {item ? null : <ExclamationCircleFilled />}
                    {item ? 1 : 0}
                  </span>
                </div>

                {item ? (
                  <div className="doc-files">
                    <div className="doc-file">
                      <span className={`doc-file__icon doc-file__icon--${kind}`}>
                        {kindIcon[kind]}
                      </span>
                      <div className="doc-file__body">
                        <a
                          className="doc-file__name"
                          href={item.url}
                          target="blank"
                        >
                          {item.name}
                        </a>
                        <span className="doc-file__meta">
                          {kind === "other"
                            ? t("File")
                            : String(item.name).split(".").pop().toUpperCase()}
                        </span>
                      </div>
                      <div className="doc-file__actions">
                        <a href={item.url} target="blank" title={t("Download")}>
                          <Dowolland width={16} height={16} />
                        </a>
                        {editable ? (
                          <button
                            type="button"
                            className="doc-file__del"
                            title={t("Delete")}
                            onClick={tile.onRemove}
                          >
                            <img src={Delete} alt="delete icon" />
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ) : null}

                {editable ? (
                  <button
                    type="button"
                    className={[
                      "doc-drop",
                      item ? "doc-drop--compact" : "",
                      dragOver === tile.letter ? "doc-drop--over" : "",
                    ].join(" ")}
                    onClick={() => tile.ref.current?.click()}
                    onDragOver={(e) => {
                      e.preventDefault();
                      if (dragOver !== tile.letter) setDragOver(tile.letter);
                    }}
                    onDragLeave={() => setDragOver(null)}
                    onDrop={(e) => {
                      e.preventDefault();
                      setDragOver(null);
                      const f = e.dataTransfer.files?.[0];
                      if (f) tile.onFile(f);
                    }}
                  >
                    <CloudUploadOutlined />
                    <span>
                      {t("drop_file")} <u>{t("drop_file_browse")}</u>
                    </span>
                  </button>
                ) : null}
              </div>
            );
          })}
        </div>
      </section>

      <div className="af-actions">
        <div className="af-actions__date">
          <i className="bx bx-calendar"></i>
          <span>{dateFormat(new Date(), "dd.mm.yyyy")}</span>
        </div>
        <div className="af-actions__buttons">
          {editable ? (
            <>
              <Button
                size="large"
                onClick={() => navigate("/account/duplicate-applications")}
              >
                {t("Cancel")}
              </Button>
              <Button type="primary" size="large" onClick={handleSave}>
                {t("Save")}
              </Button>
            </>
          ) : (
            <Button size="large" onClick={() => navigate(-1)}>
              ← {t("Back")}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
export default withTranslation()(DuplicateIntruction);
